// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1PTM0","rootSuccess":"CompleteLink_rootSuccess__BXo1o","rootFailure":"CompleteLink_rootFailure__YZT7q","isDisabled":"CompleteLink_isDisabled__3bXGs"};